module.exports = __webpack_public_path__ + "img/ilst_letter2019.66c648b8.png";